import { useModalContext } from "components/modal";
import VendorItemLinkModalBody from "../VendorBody/VendorItems/VendorItemLinkModal/VendorItemLinkModalBody";

type SetModal = ReturnType<typeof useModalContext>["setModal"];

type LinkItemModalTarget = {
	vendorId?: number | null;
	isSiteoneVendor?: boolean | null;
	isHeritageVendor: boolean;
	/** Already-translated modal title ("Link Item" / "Add Item"). */
	label: string;
};

/**
 * Open the vendor Link Item screen (the fullscreen link modal). Single assembly
 * point so every entry path — the Link Item button, and the automatic
 * navigation after a purchase-history download (#31) — lands on the identical
 * screen.
 */
export function openLinkItemModal(
	setModal: SetModal,
	{ vendorId, isSiteoneVendor, isHeritageVendor, label }: LinkItemModalTarget
) {
	setModal({
		component: (
			<VendorItemLinkModalBody
				vendorId={vendorId}
				isSiteoneVendor={isSiteoneVendor}
				isHeritageVendor={isHeritageVendor}
			/>
		),
		label,
		props: { fullScreen: true },
	});
}
